var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M414.004,303.627c-32.482,0-58.907,26.426-58.907,58.908c0,32.476,26.426,58.902,58.907,58.902    c32.487,0,58.908-26.426,58.908-58.902C472.912,330.053,446.486,303.627,414.004,303.627z M414.004,388.399    c-14.27,0-25.875-11.605-25.875-25.87c0-14.27,11.605-25.875,25.875-25.875s25.875,11.611,25.875,25.875    C439.88,376.793,428.274,388.399,414.004,388.399z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M329.221,90.563H16.516C7.394,90.563,0,97.957,0,107.08v254.348c0,9.122,7.394,16.516,16.516,16.516h51.751v-33.032    H33.032V123.596h279.673v237.832h33.032V107.08C345.738,97.957,338.344,90.563,329.221,90.563z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 149.196,
    y: 344.912,
    width: 222.417,
    height: 33.032,
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.456,303.627c-32.482,0-58.908,26.426-58.908,58.908c0,32.476,26.426,58.902,58.908,58.902    c32.482,0,58.908-26.426,58.908-58.902C167.363,330.053,140.938,303.627,108.456,303.627z M108.456,388.399    c-14.27,0-25.875-11.605-25.875-25.87c0-14.27,11.605-25.875,25.875-25.875c14.27,0,25.875,11.611,25.875,25.875    C134.331,376.793,122.72,388.399,108.456,388.399z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.484,227.647H329.221v33.032h149.746v84.232h-23.673v33.032h40.189c9.122,0,16.516-7.388,16.516-16.516V244.163    C512,235.041,504.606,227.647,495.484,227.647z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M445.545,159.127c-2.901-5.274-8.451-8.555-14.474-8.555H329.221v33.032h92.083l37.684,68.52l28.947-15.922    L445.545,159.127z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.42ee858a9dd2951598fdca2df12726e7.svg";
export { ForwardRef as ReactComponent };